import styled from "@emotion/styled";
import { size } from "../../../constants/tokens";

export const DEFAULT_SPACING = 10;

export const FilterWrapper = styled.div`
  margin-top: ${size.xxs};
  margin-left: ${size.xxs};
`;
